import { RecognitionSensorLicenseTypeEnum } from "./RecognitionSensorLicenseTypeEnum";

export class RecognitionSensorLicense {
    /**Recognition Sensor License type */
    sensorLicenseType: RecognitionSensorLicenseTypeEnum = RecognitionSensorLicenseTypeEnum.Unknown;

    /**Recognition Sensor License expiration */
    licenseExpiration: Date = null;

    public parse(obj: any) {
        if (obj.SensorLicenseType != null && Object.values(RecognitionSensorLicenseTypeEnum).includes(obj.SensorLicenseType)) this.sensorLicenseType = obj.SensorLicenseType;
        if (obj.LicenseExpiration) this.licenseExpiration = obj.LicenseExpiration;
    }
}
